import React from 'react';
import { z } from 'zod';
import { COLOR_SCHEMA } from '../color';
import { ColumnsTable } from '../columns-table';
import { PADDING_SCHEMA } from '../padding';
const FIXED_WIDTHS_SCHEMA = z
    .tuple([z.number().nullish(), z.number().nullish(), z.number().nullish()])
    .optional()
    .nullable();
export const ColumnsContainerPropsSchema = z.object({
    style: z
        .object({
        backgroundColor: COLOR_SCHEMA,
        padding: PADDING_SCHEMA,
    })
        .optional()
        .nullable(),
    props: z
        .object({
        fixedWidths: FIXED_WIDTHS_SCHEMA,
        columnsCount: z
            .union([z.literal(2), z.literal(3)])
            .optional()
            .nullable(),
        columnsGap: z.number().optional().nullable(),
        contentAlignment: z.enum(['top', 'middle', 'bottom']).optional().nullable(),
        tableWidth: z.number().min(0).max(100).optional().nullable(),
        columns: z.array(z.object({ childrenIds: z.array(z.any()) })).optional(),
    })
        .optional()
        .nullable(),
});
export function ColumnsContainer({ style, columns, props }) {
    const blockProps = {
        columnsCount: props === null || props === void 0 ? void 0 : props.columnsCount,
        columnsGap: props === null || props === void 0 ? void 0 : props.columnsGap,
        contentAlignment: props === null || props === void 0 ? void 0 : props.contentAlignment,
        fixedWidths: props === null || props === void 0 ? void 0 : props.fixedWidths,
        tableWidth: props === null || props === void 0 ? void 0 : props.tableWidth,
    };
    return React.createElement(ColumnsTable, { props: blockProps, columns: columns, style: style });
}
//# sourceMappingURL=ColumnsContainer.js.map